import { createAsyncAction, createReducer, isActionOf } from 'typesafe-actions'
import { Role } from '../../../responses/users'
import { combineReducers } from 'redux'
import { payloadReducer } from '../../../utils/redux-utils'
import { RootActions } from '../../root'
import { combineEpics, Epic } from 'redux-observable'
import { audit, filter, groupBy, map, mergeMap, startWith, switchMapTo } from 'rxjs/operators'
import { apiRequests } from '../../../http/config'
import { entityReplace, getId } from '../../../utils/entity-utils'
import { timer } from 'rxjs'
import { toastFailedResponse } from '../../../components/controls/Toaster/Toaster'

const actions = {
    list: createAsyncAction(
        '@ROLES/LIST_REQUEST',
        '@ROLES/LIST_SUCCESS',
        '@ROLES/LIST_FAILURE',
    )<string, Role[], void>(),
    update: createAsyncAction(
        '@ROLES/UPDATE_REQUEST',
        '@ROLES/UPDATE_SUCCESS',
        '@ROLES/UPDATE_FAILURE'
    )<Role, Role, void>(),
}

export { actions as rolesActions }

export interface RolesState {
    data: Role[],
}

export const rolesReducer = combineReducers<RolesState>({
    data: createReducer<Role[]>([])
        .handleAction(actions.list.success, payloadReducer)
        .handleAction([actions.update.success, actions.update.request], (state, { payload }) => entityReplace(payload)(state)),
})

const list: Epic<RootActions> = action$ => action$.pipe(
    filter(isActionOf(actions.list.request)),
    mergeMap(({ payload }) => apiRequests.role.list({ query: { search: payload } })),
    map(({ response }) => response.success ?
        actions.list.success(response.rows) :
        actions.list.failure(toastFailedResponse(response, 'Не удалось получить список ролей'))
    ),
)

const update: Epic<RootActions> = action$ => action$.pipe(
    filter(isActionOf(actions.update.request)),
    groupBy(action => action.payload.id),
    mergeMap(actionGroup$ => {
        const timer$ = actionGroup$.pipe(
            startWith(0),
            switchMapTo(timer(2000)),
        )
        return actionGroup$.pipe(
            audit(() => timer$),
        )
    }),
    mergeMap(({ payload }) => apiRequests.role.update({
        params: { roleId: payload.id },
        data: {
            is_design: payload.is_design,
            is_finplan: payload.is_finplan,
            permissions: payload.permissions.map(getId),
        },
    })),
    map(({ response }) => response.success ?
        actions.update.success(response.row) :
        actions.update.failure(toastFailedResponse(response, 'Не удалось обновить роль'))
    ),
)

export const rolesEpic = combineEpics(list, update)